import { QueryFunction, useQuery } from "@tanstack/react-query";
import { useSiloWeb3 } from "../SiloWeb3Provider";
import { fetchTowerCoordinates } from "@silo/contract-utils";
import {
  ChecksumAddress,
  ClientProvider,
  ProtocolInstance,
  getChecksumAddressOrThrow,
} from "@silo/types";

type CoordinatesKey = [
  key: "coordinates",
  clientProvider: ClientProvider,
  protocolInstance: ProtocolInstance,
  key: string
];

export const useQueryCoordinates = (key: string) => {
  const { clientProvider, protocolInstance } = useSiloWeb3();

  return useQuery({
    queryKey: ["coordinates", clientProvider!, protocolInstance!, key],
    queryFn: queryCoordinates,
    enabled: !!clientProvider && !!protocolInstance,
  });
};

const queryCoordinates: QueryFunction<
  ChecksumAddress,
  CoordinatesKey
> = async ({ queryKey: [, clientProvider, protocolInstance, key] }) => {
  const coordinates = await fetchTowerCoordinates(
    clientProvider,
    protocolInstance,
    key
  );

  return getChecksumAddressOrThrow(coordinates);
};
